//Install
import React, { Component } from "react";
//Install
import { Row, Col } from "react-bootstrap";

//Element
class G9761D extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q0w8l8" },
            //Element
            React.createElement(Row, {},
                //Element
                React.createElement(Col, { md: 8 },
                    //Element
                    React.createElement("div", { className: "S0u16d C96Q4r d721Vx pEO064 a527eB vt5278" },
                        //Element
                        React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB m0g704" },
                            //Element
                            "Şirketinize Değer Katacak Hizmetler İçin, Görüşelim."
                        )
                    )
                ),
                //Element
                React.createElement(Col, { md: 4 },
                    //Element
                    React.createElement("div", { className: "yJ452A C96Q4r vR05U6 d721Vx pEO064 a527eB f407ct" },
                        //Element
                        React.createElement( "a", { className: "S6pt64 C96Q4r pEO064 a527eB q304k4", href: "/iletisim" },
                            //Element
                            "Bilgilendirme Talebi"
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default G9761D;